import {createSelector} from '@ngrx/store';
import * as fromTranslation from './translation.reducer';
import {translationsFeatureKey} from './translation.reducer';
import {AppState} from "../../../reducers";

export const currentState = (state: AppState) => (state[translationsFeatureKey]);

export const selectTranslationsFromReducer = createSelector(currentState, fromTranslation.selectAll);
export const selectEntities = createSelector(currentState, fromTranslation.selectEntities);

export const selectAllTranslations = createSelector(
  selectTranslationsFromReducer,
  (translations) => {
    return translations.map((translation) => {
      return {
        ...translation,
      };
    });
  });

